var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkedlist" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("span", [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("pc_biz_signup_lbl_checked").d("已选")) +
                _vm._s(
                  _vm.checkedList.length ? "：" + _vm.checkedList.length : "：0"
                )
            ),
          ]),
          _vm.limit > 0
            ? _c("span", { staticStyle: { color: "#999" } }, [
                _vm._v(" /" + _vm._s(_vm.limit)),
              ])
            : _vm._e(),
        ]),
        _vm.showClearAllBtn
          ? _c(
              "yxt-button",
              { attrs: { type: "text" }, on: { click: _vm.clearAll } },
              [_vm._v(_vm._s(_vm.$t("pc_biz_labelling_clearall").d("清空")))]
            )
          : _vm._e(),
      ],
      1
    ),
    _c("main", { staticClass: "checkedlist-main" }, [
      !_vm.showClearAllBtn
        ? _c("div", { staticClass: "checkedlist-main-placeholder" }, [
            _vm._v(_vm._s(_vm.$t("biz_udp_please_select").d("请选择")) + "..."),
          ])
        : _vm._e(),
      _c("div", { staticClass: "group-main" }, [
        _c(
          "div",
          { staticClass: "group-main-content" },
          [
            _vm._l(
              _vm.checkedList.slice(0, _vm.showCount),
              function (item, key) {
                return _c(
                  "yxt-tag",
                  {
                    key: key,
                    staticClass: "mr5",
                    staticStyle: {
                      "margin-bottom": "8px",
                      "max-width": "100%",
                    },
                    attrs: {
                      size: "small",
                      type: "info",
                      disableTransitions: true,
                      closable: "",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.deleteItem(item)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "checkedlist-tag" }, [
                      _c(
                        "span",
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" },
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c(
                                  "span",
                                  [
                                    _c("yxtbiz-user-name", {
                                      attrs: { name: item.fullname },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "span",
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: item.fullname },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }
            ),
            _vm.showCount < _vm.checkedList.length
              ? _c(
                  "div",
                  [
                    _c(
                      "yxt-tag",
                      {
                        staticClass: "mr5",
                        staticStyle: {
                          "margin-bottom": "8px",
                          cursor: "pointer",
                        },
                        attrs: {
                          size: "small",
                          type: "info",
                          disableTransitions: true,
                        },
                        on: {
                          click: function () {
                            _vm.showCount += 50
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "checkedlist-tag" }, [
                          _vm._v(
                            _vm._s(_vm.$t("biz_pc_expand_more").d("展开更多"))
                          ),
                        ]),
                        _c("i", {
                          staticClass: "yxt-icon-arrow-down",
                          staticStyle: { "margin-left": "6px" },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.checkedList.length > 6 &&
            _vm.showCount >= _vm.checkedList.length
              ? _c(
                  "div",
                  [
                    _c(
                      "yxt-tag",
                      {
                        staticClass: "mr5",
                        staticStyle: {
                          "margin-bottom": "8px",
                          cursor: "pointer",
                        },
                        attrs: {
                          size: "small",
                          type: "info",
                          disableTransitions: true,
                        },
                        on: {
                          click: function () {
                            _vm.showCount = 6
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "checkedlist-tag" }, [
                          _vm._v(
                            _vm._s(_vm.$t("app_common_yxt_btn_close").d("收起"))
                          ),
                        ]),
                        _c("i", {
                          staticClass: "yxt-icon-arrow-up",
                          staticStyle: { "margin-left": "6px" },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }